import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { INITIATIVE_TYPES } from '../../../../lib/schema.js';
import { navigateToProjectReports } from '../../../links/index.jsx';

InitiativeTypesFilter.propTypes = {
  selectedTypes: PropTypes.arrayOf(PropTypes.string),
};

InitiativeTypesFilter.defaultProps = {
  selectedTypes: [],
};

function InitiativeTypesFilter({ selectedTypes }) {
  const selectedCount = selectedTypes.length;

  const handleSelect = useCallback(
    (type) =>
      navigateToProjectReports({
        types: type ? xor(selectedTypes, [type]) : [],
      }),
    [selectedTypes]
  );

  const renderMenuItem = useCallback(
    (type) => (
      <React.Fragment key={type}>
        <MenuItem
          active={selectedTypes.includes(type)}
          className="text-capitalize"
          eventKey={type}
          onSelect={handleSelect}
        >
          {type}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedTypes]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('initiative')} Type
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="initiative-types-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {INITIATIVE_TYPES.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default InitiativeTypesFilter;
